export enum TariffFeature {
    UNLIMITED_INTERNET = 2,
    SOCIAL = 3,
    MESSENGERS = 4,
    VIDEO = 5,
    MAPS = 6,
    MUSIC = 7,
    PRE_5G = 8,
    CIS_MINUTES = 9,
    WITHOUT_CALLS = 10
}